import React, { useState, useEffect } from 'react';
import { Plus, Layers, X, Trash2 } from 'lucide-react';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { formatIdade } from '../utils/formatDate';

export default function Lotes() {
  const [lotes, setLotes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({ nome:'', descricao:'', localizacao:'', capacidade:'' });

  const [loteDetalhe, setLoteDetalhe] = useState(null);
  const [animaisLote, setAnimaisLote] = useState([]);
  const [loadingAnimais, setLoadingAnimais] = useState(false);

  const load = () => api.get('/lotes').then(r => setLotes(r.data));
  useEffect(() => { load(); }, []);

  const abrir = (lote = null) => {
    setEditando(lote);
    setForm(lote ? { nome:lote.nome, descricao:lote.descricao||'', localizacao:lote.localizacao||'', capacidade:lote.capacidade||'' } : { nome:'', descricao:'', localizacao:'', capacidade:'' });
    setShowModal(true);
  };

  const salvar = async () => {
    try {
      if (editando) await api.put(`/lotes/${editando.id}`, form);
      else await api.post('/lotes', form);
      toast.success(editando ? 'Lote atualizado!' : 'Lote criado!');
      setShowModal(false); load();
    } catch (e) { toast.error(e.response?.data?.error || 'Erro'); }
  };

  const abrirDetalhe = async (lote) => {
    setLoteDetalhe(lote);
    setLoadingAnimais(true);
    try {
      const { data } = await api.get(`/lotes/${lote.id}/animais`);
      setAnimaisLote(data);
    } catch { toast.error('Erro ao carregar animais do lote'); }
    finally { setLoadingAnimais(false); }
  };

  const fecharDetalhe = () => { setLoteDetalhe(null); setAnimaisLote([]); };

  // Exclui só o cadastro do lote — animais ficam sem lote, preservados com todo o histórico.
  const excluir = async (lote) => {
    const aviso = lote.total_animais > 0
      ? `Excluir o lote "${lote.nome}"?\n\nOs ${lote.total_animais} animal(is) deste lote NÃO serão excluídos — apenas ficarão sem lote, prontos para novo enquadramento. Pesagens, intervenções e demais histórico permanecem intactos.`
      : `Excluir o lote "${lote.nome}"?`;
    if (!window.confirm(aviso)) return;
    try {
      const { data } = await api.delete(`/lotes/${lote.id}`);
      toast.success(`Lote excluído${data?.animais_desvinculados ? ` · ${data.animais_desvinculados} animal(is) liberado(s)` : ''}`);
      load();
    } catch (e) { toast.error(e.response?.data?.error || 'Erro ao excluir lote'); }
  };

  return (
    <div>
      <div className="page-header" style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
        <div><h1>Lotes</h1><p>Gestão de lotes e pastagens</p></div>
        <button className="btn btn-primary" onClick={() => abrir()}><Plus size={16} /> Novo Lote</button>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(280px, 1fr))', gap:16 }}>
        {lotes.map(l => (
          <div key={l.id} className="card" style={{ borderLeft:'4px solid var(--color-primary)', cursor:'pointer', transition:'box-shadow 0.15s' }}
            onClick={() => abrirDetalhe(l)}
            onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.10)'}
            onMouseLeave={e => e.currentTarget.style.boxShadow = ''}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:12 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <div style={{ padding:10, background:'var(--color-accent)', borderRadius:10 }}>
                  <Layers size={20} color="var(--color-primary)" />
                </div>
                <div>
                  <div style={{ fontWeight:700, fontSize:16 }}>{l.nome}</div>
                  {l.localizacao && <div style={{ fontSize:12, color:'var(--text-secondary)' }}>📍 {l.localizacao}</div>}
                </div>
              </div>
              <div style={{ display:'flex', gap:6 }}>
                <button className="btn btn-secondary btn-sm" onClick={e => { e.stopPropagation(); abrir(l); }}>Editar</button>
                <button className="btn btn-secondary btn-sm" title="Excluir lote" onClick={e => { e.stopPropagation(); excluir(l); }}>
                  <Trash2 size={14} />
                </button>
              </div>
            </div>
            {l.descricao && <p style={{ fontSize:13, color:'var(--text-secondary)', marginBottom:12 }}>{l.descricao}</p>}
            <div style={{ display:'flex', justifyContent:'space-between', paddingTop:12, borderTop:'1px solid var(--border-color)' }}>
              <div style={{ textAlign:'center' }}>
                <div style={{ fontSize:20, fontWeight:700, color:'var(--color-primary)' }}>{l.total_animais || 0}</div>
                <div style={{ fontSize:11, color:'var(--text-secondary)' }}>Animais</div>
              </div>
              {l.capacidade && (
                <div style={{ textAlign:'center' }}>
                  <div style={{ fontSize:20, fontWeight:700 }}>{l.capacidade}</div>
                  <div style={{ fontSize:11, color:'var(--text-secondary)' }}>Capacidade</div>
                </div>
              )}
              {l.capacidade && (
                <div style={{ textAlign:'center' }}>
                  <div style={{ fontSize:20, fontWeight:700, color: l.total_animais / l.capacidade > 0.9 ? 'var(--color-danger)' : 'var(--color-success)' }}>
                    {Math.round((l.total_animais / l.capacidade) * 100)}%
                  </div>
                  <div style={{ fontSize:11, color:'var(--text-secondary)' }}>Ocupação</div>
                </div>
              )}
              <div style={{ fontSize:11, color:'var(--text-secondary)', alignSelf:'flex-end', fontStyle:'italic' }}>ver animais →</div>
            </div>
          </div>
        ))}
        {lotes.length === 0 && (
          <div className="card" style={{ gridColumn:'1/-1' }}>
            <div className="empty-state"><p>Nenhum lote cadastrado</p></div>
          </div>
        )}
      </div>

      {/* ═══ MODAL ANIMAIS DO LOTE ═══ */}
      {loteDetalhe && (
        <div className="modal-overlay" onClick={fecharDetalhe}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth:720, maxHeight:'85vh', overflow:'auto', width:'95%' }}>
            <div className="modal-header" style={{ position:'sticky', top:0, background:'var(--bg-card)', zIndex:10 }}>
              <div>
                <h2 style={{ display:'flex', alignItems:'center', gap:8 }}><Layers size={18} /> {loteDetalhe.nome}</h2>
                {loteDetalhe.localizacao && <div style={{ fontSize:13, color:'var(--text-secondary)' }}>📍 {loteDetalhe.localizacao}</div>}
              </div>
              <button className="btn btn-secondary btn-sm" onClick={fecharDetalhe}><X size={15}/></button>
            </div>
            <div className="modal-body" style={{ padding:0 }}>
              {loadingAnimais ? (
                <div style={{ textAlign:'center', padding:50, color:'var(--text-secondary)' }}>Carregando...</div>
              ) : animaisLote.length === 0 ? (
                <div className="empty-state" style={{ padding:40 }}><p>Nenhum animal ativo neste lote</p></div>
              ) : (
                <table>
                  <thead><tr>
                    <th>Brinco</th><th>Nome</th><th>Sexo</th><th>Raça</th><th>Categoria</th><th>Idade</th>
                  </tr></thead>
                  <tbody>
                    {animaisLote.map(a => (
                      <tr key={a.id}>
                        <td><strong style={{ color:'var(--color-primary)' }}>{a.brinco}</strong></td>
                        <td>{a.nome || '—'}</td>
                        <td><span className={`badge ${a.sexo==='M'?'badge-blue':'badge-orange'}`}>{a.sexo==='M'?'Macho':'Fêmea'}</span></td>
                        <td style={{ fontSize:13 }}>{a.raca_nome || '—'}</td>
                        <td><span className="badge badge-green" style={{ textTransform:'capitalize', fontSize:11 }}>{a.categoria || '—'}</span></td>
                        <td style={{ color:'var(--text-secondary)', fontSize:13 }}>{formatIdade(a.data_nascimento)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            <div className="modal-footer">
              <span style={{ fontSize:13, color:'var(--text-secondary)' }}>{animaisLote.length} animal(is) ativo(s)</span>
              <button className="btn btn-secondary" onClick={fecharDetalhe}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      {/* ═══ MODAL CADASTRO/EDIÇÃO ═══ */}
      {showModal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowModal(false)}>
          <div className="modal">
            <div className="modal-header"><h2>{editando ? 'Editar Lote' : 'Novo Lote'}</h2><button className="btn btn-secondary btn-sm" onClick={() => setShowModal(false)}>✕</button></div>
            <div className="modal-body">
              <div className="form-group"><label>Nome do Lote *</label><input value={form.nome} onChange={e => setForm(p => ({ ...p, nome:e.target.value }))} placeholder="Ex: Lote A — Matrizes" /></div>
              <div className="form-row">
                <div className="form-group"><label>Localização</label><input value={form.localizacao} onChange={e => setForm(p => ({ ...p, localizacao:e.target.value }))} placeholder="Ex: Pasto Norte" /></div>
                <div className="form-group"><label>Capacidade (animais)</label><input type="number" value={form.capacidade} onChange={e => setForm(p => ({ ...p, capacidade:e.target.value }))} /></div>
              </div>
              <div className="form-group"><label>Descrição</label><textarea rows={2} value={form.descricao} onChange={e => setForm(p => ({ ...p, descricao:e.target.value }))} /></div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar} disabled={!form.nome}>Salvar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
